import React, {Fragment} from 'react';
import PageHeader from "../../components/elements/PageHeader";
import {translate} from "react-i18next";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import CompanyApi from "../../apis/CompanyApi";
import EditCompany from "./EditCompany";
import AddQuota from "./AddQuota";
import {companiesUpdated} from "../../actions/companyAction";
import DeleteQuota from "./DeleteQuota";
import EditQuota from "./EditQuota";

class Company extends React.Component {

    state = {
        loading: true,
        company: null
    };

    componentDidMount() {
        this.loadCompany();
    }

    loadCompany = () => {
        this.setState({loading: true});
        CompanyApi.getCompany(this.props.match.params.id)
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        loading: false,
                        company: response.data.data
                    });
                }
            })
    };

    addCompanyToProject = () => {
        this.setState({loading: true});
        CompanyApi.addCompanyToProject(this.props.match.params.id)
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        loading: false,
                        company: response.data.data
                    });
                    this.props.companiesUpdated();
                }
            })
    };

    removeCompanyFromProject = () => {
        this.setState({loading: true});
        CompanyApi.removeCompanyFromProject(this.props.match.params.id)
            .then((response) => {
                if (response.data.success) {
                    this.setState({
                        loading: false,
                        company: response.data.data
                    });
                    this.props.companiesUpdated();
                }
            })
    };

    render() {
        const {t} = this.props;
        const {company} = this.state;
        let companyFromStore = this.props.company.companies.find(el => el.id === parseInt(this.props.match.params.id));
        let currentProject = this.props.project.selectedProject;
        let companyProject = company ? company.projects.find(el => el.project === currentProject.id) : null;
        return companyFromStore ? (
            <div className="Company">
                <PageHeader title={companyFromStore.name} loading={this.state.loading} subtitle={(
                    <Link to="/companies">
                        {t('company.backToOverview')}
                    </Link>
                )}/>
                {company ? (
                    <Fragment>
                        <div className="row m-t">
                            <div className="col-xs-6">
                                <div className="ibox">
                                    <div className="ibox-title">
                                        <h5>{t('company.companyData.title')}</h5>
                                        <div className="ibox-tools">
                                            <EditCompany company={company} onSuccess={this.loadCompany}/>
                                        </div>
                                    </div>
                                    <div className="ibox-content">
                                        <div className="row">
                                            <div className="col-xs-6">
                                                {company.name}
                                                {company.shortName ? (
                                                    <span>&nbsp;({company.shortName})</span>
                                                ) : null}<br/>
                                                {(company.address.street || company.address.streetNumber || company.address.city || company.address.zipcode) ? (
                                                    <span>{company.address.street} {company.address.streetNumber}<br/>{company.address.zipcode} {company.address.city}</span>
                                                ) : null}
                                                {company.taxNumber ? (
                                                    <div><br/>{t('company.companyData.taxNumber')}: {company.taxNumber}
                                                    </div>
                                                ) : null}
                                            </div>
                                            <div className="col-xs-6">
                                                {company.mail ? (
                                                    <div>{company.mail}</div>
                                                ) : null}
                                                {company.phone ? (
                                                    <div>{company.phone}</div>
                                                ) : null}
                                                {company.contactPerson ? (
                                                    <div>{t('company.companyData.contactPerson')}: {company.contactPerson}</div>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {currentProject ? (
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="ibox">
                                        <div className="ibox-title">
                                            <h5>{currentProject.displayName}</h5>
                                        </div>
                                        <div className="ibox-content">
                                            {companyProject ? (
                                                <div>
                                                    <div className="text-right">
                                                        <button className="btn btn-danger"
                                                                onClick={this.removeCompanyFromProject}>{t('company.companyProject.remove')}</button>
                                                    </div>
                                                    <div className="m-t">
                                                        <h4>{t('company.companyProject.quotas.title')}</h4>
                                                        <table className="table table-bordered">
                                                            <thead>
                                                            <tr>
                                                                <th>
                                                                    {t('company.companyProject.quotas.table.workType')}
                                                                </th>
                                                                <th>
                                                                    {t('company.companyProject.quotas.table.amount')}
                                                                </th>
                                                                <th>
                                                                    {t('company.companyProject.quotas.table.pay')}
                                                                </th>
                                                                <th>
                                                                    {t('company.companyProject.quotas.table.night')}
                                                                </th>
                                                                <th>
                                                                    {t('company.companyProject.quotas.table.nightExtra')}
                                                                </th>
                                                                <th>
                                                                    {t('company.companyProject.quotas.table.sundayExtra')}
                                                                </th>
                                                                <th>
                                                                    {t('company.companyProject.quotas.table.bankHolidayExtra')}
                                                                </th>
                                                                <th/>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            {companyProject.quotas ? companyProject.quotas.map((quota, qI) => (
                                                                <tr key={qI}>
                                                                    <td>
                                                                        {quota.workType.name}
                                                                    </td>
                                                                    <td>
                                                                        {!quota.amountUnlimied ? quota.amount : ''}
                                                                    </td>
                                                                    <td>
                                                                        {quota.pay ? (
                                                                            <span>
                                                                                {quota.pay.toLocaleString('de-DE', {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 2
                                                                                })} €
                                                                            </span>
                                                                        ) : null}
                                                                    </td>
                                                                    <td>
                                                                        {(quota.nightStart && quota.nightEnd) ? (
                                                                            <span>
                                                                                {quota.nightStart} - {quota.nightEnd}
                                                                            </span>
                                                                        ) : null}
                                                                    </td>
                                                                    <td>
                                                                        {quota.nightExtra} %
                                                                    </td>
                                                                    <td>
                                                                        {quota.sundayExtra} %
                                                                    </td>
                                                                    <td>
                                                                        {quota.bankHolidayExtra} %
                                                                    </td>
                                                                    <td className="text-right">
                                                                        <div className="btn-group btn-group-xs">
                                                                            <EditQuota company={company}
                                                                                       companyProject={companyProject}
                                                                                       onSuccess={this.loadCompany}
                                                                                       quota={quota}/>
                                                                            <DeleteQuota id={quota.id}
                                                                                         onSuccess={this.loadCompany}/>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )) : null}
                                                            </tbody>
                                                        </table>
                                                        <AddQuota company={company} companyProject={companyProject}
                                                                  onSuccess={this.loadCompany}/>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    {t('company.companyProject.notSet')}<br/>
                                                    <button className="btn btn-secondary m-t"
                                                            onClick={this.addCompanyToProject}>{t('company.companyProject.add')}</button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : null
                        }
                    </Fragment>
                ) : null}
            </div>
        ) : null
    }
}

const mapStateToProps = state => {
    return {
        company: state.company,
        project: state.project
    }
};

export default connect(mapStateToProps, {
    companiesUpdated
})(translate()(Company));
